<template>
  <!-- Banner -->
  <div class="title-banner--watermark">
    <div class="container">
      <div class="row title-banner">
        <div class="page-title col mb-4 mt-2" role="banner" aria-label="Page Title Banner">
          <h1>Search contacts</h1>
          <form class="form" @submit.prevent="handleFormSubmit">
            <div class="search-box">
              <input
                type="text"
                placeholder="Enter a search term"
                class="search-box--input"
                v-model="keywords" autofocus="autofocus"
                @input="handleInputChange"
                @focus="focussed = true" @blur="delayUnfocus"
              />
              <button v-show="keywords" class="btn-clear bg-transparent" type="button" @click="clearSearch"><i class="fa fa-times"></i></button>
              <ul v-if="isActive" class="search-suggestions">
                <li><strong>Suggestions</strong></li>
                <li class="clickable" v-for="result in suggestionState.results" :key="result.id.raw" @click.prevent="searchSuggestion(result.title?.raw)">
                  {{ result.title?.raw }}
                </li>
                <li v-show="!thereAreResults">No suggestion found</li>
              </ul>
            </div>
            <button type="submit">
              <i class="fas fa-search" aria-hidden="true"></i>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- End banner -->
</template>

<script setup>
import { watch, computed, onMounted, ref } from 'vue'
import debounce from 'common/helpers/debounce.js'
import config from "/client/js/searchConfig.js"
import { SearchDriver } from "@elastic/search-ui"
import { sleep } from 'common/helpers/async-tools.js'
import { useRoute } from 'vue-router';

// Get the route object
const route = useRoute();
const props = defineProps(['modelValue'])

// Don't track suggestions settings in the URL...
const localDriver = new SearchDriver({trackUrlState: false, ...config})
// Always use "relevance" search for suggestions
localDriver.setSort('', 'asc')

const emit = defineEmits(['update:modelValue', 'doSearch'])

const keywords = ref('')

const suggestionState = ref({})
const focussed = ref(false)
const isActive = ref(false)
//const isActive = computed(() => focussed.value && keywords.value != null && keywords.value !== '')
const thereAreResults = computed(() => suggestionState.value.totalResults && suggestionState.value.totalResults > 0 )

function handleInputChange() {
  // Set isActive to true if keywords is not empty or null
  isActive.value = computed(() => focussed.value && keywords.value != null && keywords.value !== '')
}

// Watch for changes in the route query
watch(() => props.modelValue, (newVal) => {
  // Check if the 'q' query parameter exists before trying to access it
  if (keywords.value == '') {
    keywords.value = newVal;
  }
})

//Methods
const clearSearch = () => {
  keywords.value = ''
}

async function delayUnfocus() {
  // Need to pause, otherwise we can't click on things in the popup
  await sleep(250)
  focussed.value = false
  isActive.value = false
}

function handleFormSubmit() {
  // Update main search
  emit('update:modelValue', keywords.value)

  // Trigger main search
  emit('doSearch')

  // Treat input field as unfocussed on form submit (to show main page results)
  focussed.value = false
  isActive.value = false
}

function searchSuggestion(suggestion) {
  console.log('searchSuggestion', suggestion)
  keywords.value = suggestion
  handleFormSubmit()
}

const debouncedSearch = debounce(() => {
  console.log('Debounced Update Filters', keywords)

  // Update main search
  emit('update:modelValue', keywords.value)

  // Do suggestion search
  localDriver.getActions().setSearchTerm(keywords.value)
}, 250)

watch(keywords, () => {
  // Treat input field as focussed as soon as a key is pressed
  focussed.value = true

  debouncedSearch()
})

onMounted(() => {
  const { searchTerm } = localDriver.getState()

  // restoring UI from url query
  keywords.value = searchTerm || ''
  emit('update:modelValue', keywords.value)

  // Search result update
  localDriver.subscribeToStateChanges(state => {
    console.log('Result', state)
    suggestionState.value = state
  })
})
</script>